export default __webpack_public_path__ + "static/media/catchTheNextDrop.46b81e40.png";